import { Component, HostBinding, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from '@coin/shared/auth/data-access';
import { EquityPageComponentModel } from '../../models/equity-page-component.model';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'customer-app-equity-media',
  templateUrl: './equity-media.component.html',
  styleUrls: ['./equity-media.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon, V2ButtonComponent, TranslatePipe]
})
export class EquityMediaComponent implements OnInit, EquityPageComponentModel {
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly authService = inject(AuthService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() data: any;
  @HostBinding('class.contrast') contrast: boolean;

  ngOnInit(): void {
    this.contrast = this.data?.options?.contrast;
  }

  login(): void {
    this.authService.login();
  }

  getSanitizedUrl(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
